import React from "react";
import { Container, Typography, List, ListItem, ListItemButton, ListItemText, Divider, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";


const siteMapStructure = [
    {
        header: "Information",
        links: [
            { label: "Home", path: "/" },
            { label: "About Us", path: "/about-us" },
            { label: "FAQ", path: "/faq" },
            { label: "Terms of Service", path: "/terms-of-service" },
            { label: "Privacy Policy", path: "/privacy-policy" },
            { label: "Contact Us", path: "/contact" },
            { label: "Supporting Stylisher", path: "/support" },
        ]
    },
    {
        header: "Resources",
        links: [
            { label: "Resource Hub", path: "/resource-hub" },
            { label: "Lebron Values Userscript", path: "/userscript" },
            { label: "Token Search", path: "/token-search" },
            { label: "Beginner's Guide to NC", path: "/guides/beginner-nc-guide" },
            { label: "All About BFGBCs", path: "/articles/bfgbc" },
            { label: "Anniversary NC Quiz", path: "/articles/anniversary-nc-quiz" },
            { label: "Drop Rate Simulator", path: "/articles/drop-rate-simulator" },
            { label: "How a Value Guide Works", path: "/guides/how-a-value-guide-works" },
            { label: "How to Buy NC", path: "/guides/buying-nc" },
            { label: "How to Use LebronBot", path: "/guides/how-to-lebron" },
            { label: "Hunting Down Hard to Find Items", path: "/guides/hunting-htf-items" },
            { label: "Miscellaneous NC Knowledge", path: "/articles/misc-nc-knowledge" },
            { label: "MME", path: "/articles/mme" },
            { label: "NC Shuffles", path: "/guides/nc-shuffles" },
            { label: "Neoboard Fonts", path: "/articles/neosignatures" },
            { label: "Token Trading Guide", path: "/guides/token-trading" },
            { label: "Ways to Determine and Interpret Values", path: "/articles/values" },
        ]
    },
    {
        header: "Updates",
        links: [
            { label: "Main Updates Page", path: "/updates" },
            { label: "September 2025 - We've Launched!", path: "/updates/sept-2025" },
            { label: "November 2025 - Token Search + More!", path: "/updates/nov-2025" },
            { label: "June 2026 - Happy One Year!", path: "/updates/june-2026" },
            { label: "October 2026 - Now Fansite Certified!", path: "/updates/oct-2026" },
        ]
    },

];

const SiteMap = () => {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <Typography variant="h4" sx={{ mb: 3, fontWeight: 600, color: theme.palette.accent.main }}>
                Site Map
            </Typography>

            <Stack spacing={4}>
                {siteMapStructure.map((section, idx) => (
                    <div key={idx}>
                        <Typography variant="h6" sx={{ mb: 1, color: theme.palette.secondary.main }}>
                            {section.header}
                        </Typography>
                        <List disablePadding>
                            {section.links.map((link, i) => (
                                <ListItem key={i} disablePadding>
                                    <ListItemButton onClick={() => navigate(link.path)}>
                                        <ListItemText primary={link.label} />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>
                        {idx < siteMapStructure.length - 1 && <Divider sx={{ mt: 3 }} />}
                    </div>
                ))}
            </Stack>
        </Container>
    );
};

export default SiteMap;